import {Button, Col, Row, Table} from 'antd';
import {ColumnsType} from 'antd/lib/table';
import {Fragment, useState} from 'react';
import {RiEdit2Line} from 'react-icons/ri';
import IntlMessages from '../../../../../../../domain/utility/IntlMessages';
import {INDEX_PAGE_SIZE_OPTIONS} from '../../../../../../../shared/constants/AppConst';
import {PredefinedColorValueSubColorListDto} from '../../../../../../../shared/services/product-attribute/dto/predefined-color-value-sub-color-list-dto';
import EditManageSubColorModal from '../edit-manage-sub-color-modal';
import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import useTableV2 from 'src/shared/hooks/useTableV2';

interface IManageSubColorTableProps {
  subColorListTotal: number;
  subColorList: PredefinedColorValueSubColorListDto[];
  isTableLoading: boolean;
  pagination: IPaginateProducts;
  setPagination: any;
  getSubColorList: () => void;
}

const ManageSubColorTable = (props: IManageSubColorTableProps) => {
  const {
    subColorList,
    isTableLoading,
    getSubColorList,
    subColorListTotal,
    pagination,
    setPagination,
  } = props;
  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);
  const [
    editManageSubColorModalVisbility,
    setEditManageSubColorModalVisbility,
  ] = useState(false);
  const [subColorDetails, setSubColorDetails] = useState<
    PredefinedColorValueSubColorListDto | undefined
  >(undefined);
  const {locale}: any = useLocaleContext();
  const {showTotal, ...tableV2} = useTableV2();
  const tablePagination = {
    total: subColorListTotal,
    pageSizeOptions: pageSizeOptions,
    pageSize: pagination.PageSize,
    showSizeChanger: true,
    showTotal,
    current: pagination.Page,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPagination({
        Page: current,
        PageSize: PageSize,
      });
    },
    onChange: (page: any, pageSize: any) => {
      setPagination({
        Page: page,
        PageSize: pageSize,
      });
    },
  };

  const openEditManageSubColorModal = (
    item: PredefinedColorValueSubColorListDto,
  ) => {
    setEditManageSubColorModalVisbility(true);
    setSubColorDetails(item);
  };

  const columns: ColumnsType<any> = [
    {
      title: (
        <IntlMessages id='productAttributes.productAttributesPredefinedValues.subColor' />
      ),
      dataIndex: 'Name',
      key: 'Name',
      width: '80%',
      render: (value: string, record: PredefinedColorValueSubColorListDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='common.Action' />,
      key: 'action',
      render: (value, record: PredefinedColorValueSubColorListDto, index) => {
        return (
          <Row justify='center'>
            <Col>
              <Button
                type='primary'
                onClick={() => openEditManageSubColorModal(record)}
                icon={<RiEdit2Line className='add-button-icon' />}
                size='small'
                className='add-button'>
                <IntlMessages id='common.edit' />
              </Button>
            </Col>
          </Row>
        );
      },
      className: 'col-actions',
      width: 120,
      ellipsis: true,
    },
  ];

  const onCancelModal = () => {
    setEditManageSubColorModalVisbility(false);
  };

  const onFinishModal = async () => {
    setEditManageSubColorModalVisbility(false);
    await getSubColorList();
  };

  const renderEditManageSubColorModal = () => {
    return (
      <EditManageSubColorModal
        visible={editManageSubColorModalVisbility}
        subColorDetails={subColorDetails}
        onCancel={onCancelModal}
        onFinish={onFinishModal}
      />
    );
  };

  return (
    <Fragment>
      <Table
        columns={columns}
        rowKey={(record: any) => record.Id?.toString()}
        dataSource={subColorList}
        pagination={tablePagination}
        bordered={true}
        loading={isTableLoading}
        {...tableV2}
      />
      {renderEditManageSubColorModal()}
    </Fragment>
  );
};

export default ManageSubColorTable;
